import { useRef } from 'react';

/**
 * 한 번 누르면 한 번만 나간다. `isPending` 은 다음 렌더에야 참이 되어 Enter 와 클릭이 겹치면 둘 다 지나간다 —
 * 2026-11-03 운영에서 같은 OTP 6자리가 두 번 동시에 들어가 서버가 멈췄다(TotpService.verify 주석).
 *
 * 쓰는 법: `once((done) => mutation.mutate(input, { onSettled: done }))`.
 */
export function useSingleFlight() {
  const busy = useRef(false);
  return (run: (done: () => void) => void) => {
    if (busy.current) return;
    busy.current = true;
    run(() => {
      busy.current = false;
    });
  };
}
